import { Backdrop, Paper, Box, LinearProgress, Typography, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useBatchStore } from "../../../hooks/useBatchStore";
import { alpha, useTheme } from "@mui/material/styles";

export default function BatchProgressModal() {
  const { isOpen, title, total, processed, errorCount, status, cancel } = useBatchStore();
  const theme = useTheme();
  const progress = total > 0 ? Math.round((processed / total) * 100) : 0;

  return (
    <Backdrop
      open={isOpen}
      sx={{
        zIndex: (t) => t.zIndex.modal + 10,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          width: 420,
          p: 2,
          borderRadius: 2, // usa shape del tema
          bgcolor: "background.paper",
          color: "text.primary",
          boxShadow: `0 12px 30px ${alpha(theme.palette.common.black, 0.15)}`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="subtitle1" fontWeight={700}>
            {title || "Procesando documentos..."}
          </Typography>
          {status === "running" && (
            <Tooltip title="Ocultar (el proceso continúa)">
              <IconButton size="small" onClick={cancel} sx={{ color: "text.secondary" }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {processed} de {total} ({progress}%)
        </Typography>

        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 6,
            borderRadius: 999,
            bgcolor: alpha(theme.palette.primary.main, 0.18), // track tenue
            "& .MuiLinearProgress-bar": {
              borderRadius: 999,
              backgroundColor: theme.palette.primary.main, // barra = color de marca
            },
          }}
        />

        {!!errorCount && (
          <Typography variant="caption" color="error.main" sx={{ mt: 1, display: "block" }}>
            Errores: {errorCount}
          </Typography>
        )}
      </Paper>
    </Backdrop>
  );
}
